// extracted by mini-css-extract-plugin
module.exports = {"header":"provincelinks_header__mf6Ll","sublink":"provincelinks_sublink__rOzjt"};